module.exports = __webpack_public_path__ + "img/s3.0f2501ff.png";